import styled from 'styled-components'

export const MenuContainer = styled.div``
